import React from 'react';
import CalculateRates from '../../Containers/ShippingContainer/CalculateRates';

const Calculation = (props) => {
	return (
		<CalculateRates {...props}/>
	);
}

export default Calculation;
